import React, { useEffect } from 'react'
import './Privacy.css'

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className='px-4 py-6 md:px-12 md:py-8 bg-black text-white'>
            {/* Hero Section */}
            <div className='myBg h-64 mb-12 flex flex-col justify-center items-center bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg shadow-lg'>
                <p className='text-white text-3xl sm:text-4xl md:text-5xl font-extrabold animate__animated animate__fadeIntext-center text-white text-lg sm:text-xl md:text-xl font-semibold -mt-4 mb-4 bg-gradient-to-r from-gold1 to-yellow-350 p-6 rounded-xl shadow-lg transform hover:scale-105 transition duration-300 ease-in-out max-w-lg mx-auto'   >
                    Privacy Policy
                </p>
            </div>

            {/* Introduction */}
            <section className='animate__animated animate__fadeIn animate__delay-1s'>
                <p className='text-sm sm:text-lg md:text-xl mt-2'>
                    Shambhuraj Khamkar's Trading Academy ("SKTA," "we," "us," or "our") respects the privacy of our users ("you" or "your"). This Privacy Policy describes the types of information we collect about you when you visit our website, learn.skta.in ("Website"), and how we use that information.
                </p>
            </section>

            {/* Information We Collect */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-1.5s'>
                    Information We Collect
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-2s'>
                    We collect several types of information to provide and improve our services to you:
                </p>
                <ul className="ml-4 sm:ml-6 md:ml-8 mt-2 list-disc pl-5">
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-2.5s">Personal Information: This may include your name, email address, phone number, and any other information you choose to provide when registering for courses, contacting us, or participating in interactive features on the Website.</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-3s">Usage Data: We may collect information about how you use the Website, such as the pages you visit, the courses you view, and the resources you download. This data is collected through cookies and other tracking technologies.</li>
                </ul>
            </section>

            {/* How We Use Your Information */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-3.5s'>
                    How We Use Your Information
                </p>
                <ul className="ml-4 sm:ml-6 md:ml-8 mt-2 list-disc pl-5">
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-4s">To provide and improve our services, including delivering course content, processing enrollment requests, and managing your account.</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-4.5s">To send you important information about SKTA, such as course updates, account notices, and promotional offers (with your consent).</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-5s">To personalize your experience on the Website by recommending courses and resources that may be of interest to you.</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-5.5s">To analyze how users interact with the Website to improve its functionality and user experience.</li>
                </ul>
            </section>

            {/* Cookies Section */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-6s'>
                    Cookies and Tracking Technologies
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-7s'>
                    We use cookies and other tracking technologies to collect and store some of the data mentioned above. Cookies are small data files placed on your device that help us remember information about you and your preferences. You can control how cookies are used by adjusting your browser settings. Most browsers allow you to block or delete cookies. However, blocking cookies may limit your ability to use certain features of the Website.
                </p>
            </section>

            {/* Sharing Your Information */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-7.5s'>
                    Sharing Your Information
                </p>
                <ul className="ml-4 sm:ml-6 md:ml-8 mt-2 list-disc pl-5">
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-8s">With service providers who help us operate the Website and provide our services. These service providers are bound by contractual obligations to keep your information confidential.</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-8.5s">To comply with legal or regulatory requirements.</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-9s">To protect the rights, property, or safety of SKTA, our users, or the public.</li>
                </ul>
            </section>

            {/* Data Retention */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-10s'>
                    Data Retention
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-10.5s'>
                    We will retain your personal information for as long as necessary to fulfil the purposes described in this Privacy Policy, unless a longer retention period is required or permitted by law.
                </p>
            </section>

            {/* Your Rights */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-11s'>
                    Your Rights
                </p>
                <ul className="ml-4 sm:ml-6 md:ml-8 mt-2 list-disc pl-5">
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-12s">The right to access your personal information</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-12.5s">The right to rectify any inaccuracies in your personal information</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-13s">The right to request the erasure of your personal information</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-13.5s">The right to object to the processing of your personal information</li>
                    <li className="text-sm sm:text-base md:text-lg animate__animated animate__fadeIn animate__delay-14s">The right to withdraw your consent (where applicable)</li>
                </ul>
            </section>

            {/* Children's Privacy */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-14.5s'>
                    Children's Privacy
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-15s'>
                    Our Website is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us. We will take steps to remove the information from our systems.
                </p>
            </section>

            {/* Changes to this Privacy Policy */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-15.5s'>
                    Changes to this Privacy Policy
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-16s'>
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on the Website. You are advised to review this Privacy Policy periodically for any updates.
                </p>
            </section>

            {/* Contact Us */}
            <section className='mt-8'>
                <p className='text-lg sm:text-xl md:text-2xl font-semibold animate__animated animate__fadeIn animate__delay-16.5s'>
                    Contact Us
                </p>
                <p className='text-sm sm:text-lg md:text-xl mt-2 animate__animated animate__fadeIn animate__delay-17s'>
                    If you have any questions about this Privacy Policy, please contact us at <b style={{ color: '#DBB76A' }}>9822500374</b>.
                </p>
            </section>
        </div>
    )
}

export default Privacy;
